import * as React from 'react';

import type { CampaignAnalysisClient } from '@/api/campaign-analysis-client';
import { HttpCampaignAnalysisClient } from '@/api/campaign-analysis-client.http';

// =============================================================================
// campaign-analysis-client-context.tsx — Injection du CampaignAnalysisClient (DI seam).
// =============================================================================
// Permet de substituer le client sans toucher l'UI. Par défaut (S17) : l'adaptateur HTTP RÉEL
// (HttpCampaignAnalysisClient) — le câblage front↔back contre le contrat de routes figé D1. Les
// tests de composant injectent le StubCampaignAnalysisClient (double déterministe) via le provider.

/** Adaptateur par défaut : HTTP réel (chemins relatifs racine API, cookie de session admin). */
const defaultCampaignAnalysisClient: CampaignAnalysisClient =
  new HttpCampaignAnalysisClient();

const CampaignAnalysisClientContext =
  React.createContext<CampaignAnalysisClient>(defaultCampaignAnalysisClient);

export interface CampaignAnalysisClientProviderProps {
  client?: CampaignAnalysisClient | undefined;
  children: React.ReactNode;
}

export function CampaignAnalysisClientProvider({
  client = defaultCampaignAnalysisClient,
  children,
}: CampaignAnalysisClientProviderProps): React.JSX.Element {
  return (
    <CampaignAnalysisClientContext.Provider value={client}>
      {children}
    </CampaignAnalysisClientContext.Provider>
  );
}

export function useCampaignAnalysisClient(): CampaignAnalysisClient {
  return React.useContext(CampaignAnalysisClientContext);
}
